<template>
    <div class="survey-form">
        <div class="survey-form-main">
            <h1 class="heading-name" v-if="surveyData">{{ surveyData.name }}</h1>
            <div class="survey-content">
                <div class="form">
                    <form v-if="!loading && !error && parsedQuestions.length" @submit.prevent="submitSurvey">
                        <div class="survey-content-questions">
                            <div v-for="(question, index) in parsedQuestions" :key="index" class="question">
                                <p>{{ question.content }}</p>
                                <div v-if="question.type === 'mutiple_choice'">
                                    <div class="choice" v-for="(answer, idx) in question.answers" :key="idx">
                                        <input style="margin-right: 12px; padding: 2px;" type="checkbox"
                                            :id="'q' + index + '-a' + idx" :value="answer"
                                            :checked="answers[question.id] && answers[question.id].includes(answer)"
                                            @change="updateMultipleChoice(question.id, answer, $event)" />
                                        <label :for="'q' + index + '-a' + idx">{{ answer }}</label>
                                    </div>
                                </div>
                                <div v-if="question.type === 'single_choice'">
                                    <div class="choice" v-for="(answer, idx) in question.answers" :key="idx"
                                        :class="{ selected: answers[question.id] === answer }">
                                        <input class="choice-input" type="radio" :id="'q' + index + '-a' + idx"
                                            v-model="answers[question.id]" :value="answer"
                                            :name="'question' + question.id"/>
                                        <label :for="'q' + index + '-a' + idx">{{ answer }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="box-submit">
                            <button type="submit" class="btn btn-submit">Hoàn thành khảo sát nhanh</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

export default {
    data() {
        return {
            surveyData: null,
            parsedQuestions: [],
            answers: {},
            loading: true,
            error: false,
        };
    },
    computed: {
        ...mapState('auth', ['isLoggedIn']),
    },
    methods: {
        async fetchSurvey() {
            try {
                this.loading = true;
                const token = this.$store.state.auth.token;
                const response = await axios.get('https://api.tryhsk.com/api/surveys', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.data.success) {
                    this.surveyData = response.data.data;
                    this.parsedQuestions = JSON.parse(this.surveyData.questions);
                    this.initializeAnswers();
                } else {
                    this.error = true;
                    // chuyển hướng về trang chủ
                    this.$router.push({ name: "thi-thu" });
                }
            } catch (err) {
                this.error = true;
                console.error('Lỗi khi lấy dữ liệu khảo sát:', err);
            } finally {
                this.loading = false;
            }
        },
        initializeAnswers() {
            this.parsedQuestions.forEach((question) => {
                this.answers[question.id] = question.type === 'mutiple_choice' ? [] : null;
                this.answers[question.id] = question.type === 'single_choice' ? null : [];
            });
        },
        updateMultipleChoice(questionId, answer, event) {
            const isChecked = event.target.checked;
            if (isChecked) {
                if (!this.answers[questionId].includes(answer)) {
                    this.answers[questionId].push(answer);
                }
            } else {
                this.answers[questionId] = this.answers[questionId].filter((item) => item !== answer);
            }
        },
        skipSurvey() {
            this.$router.push({ name: 'thi-thu' });
        },
        async submitSurvey() {
            try {
                if (this.loading) return;
                this.loading = true;
                const formattedAnswers = this.parsedQuestions.map((question) => ({
                    id: question.id,
                    content: Array.isArray(this.answers[question.id])
                        ? this.answers[question.id]
                        : [this.answers[question.id]],
                }));
                const payload = {
                    survey_id: this.surveyData.id,
                    answer: JSON.stringify(formattedAnswers),
                };
                const token = this.$store.state.auth.token;
                const response = await axios.post('https://api.tryhsk.com/api/surveys', payload, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.data.success) {
                    // alert('Cảm ơn bạn đã tham gia khảo sát!');\
                    this.$router.push({ name: "thi-thu" });
                } else {
                    alert('Gửi khảo sát thất bại. Vui lòng thử lại!');
                    this.loading = false;
                }
            } catch (error) {
                console.error('Lỗi khi gửi khảo sát:', error);
                this.loading = false;
            }
        },
    },
    mounted() {
        this.fetchSurvey();
    },
};
</script>

<style scoped>
.heading-name {
    margin-bottom: 20px;
}

.survey-form-main {
    padding-top: 30px;
}

.survey-form {
    display: flex;
    justify-content: center;
    align-items: center;
}

.survey-content-questions {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.question {
    border-left: 2px solid #17a2b8;
}

.error {
    color: red;
}

.box-submit {
    display: flex;
    justify-content: center;
    margin-top: 22px;
    margin-bottom: 22px;
}

.box-next {
    display: flex;
    justify-content: flex-end;
}

.btn {
    padding: 10px 20px;
    border-radius: 8px;
    background-color: #17a2b8;
    color: white;
}

.form input {
    margin-right: 12px;
    width: 22px;
    height: 22px;
    cursor: pointer;
}

.form label {
    margin-bottom: 0 !important;
    cursor: pointer;
}

.choice {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}


</style>